import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AnalyticsService } from "./analytics.service";

@Injectable()
export class QuotesService {
  constructor(private http: HttpClientService, private analyticsService: AnalyticsService) {}

  public deleteQuote(quote_id): Observable<any> {
    return this.http.delete("/api/quotes/" + quote_id).pipe(tap((_) => console.log("QuotesService.deleteQuote: Ok.")));
  }

  public getStep(quote_id: number | string, step: string) {
    let options = {
      params: { step: step },
    };
    return this.http
      .get("/api/quotes/" + quote_id + "/visitas/last_step", options)
      .pipe(tap((_) => console.log("QuoteService.getStep: Ok.")));
  }

  public schedule(quote_id: string | number, time: string, activity_id: string | number, action: string) {
    let params = { activity_id: activity_id as string, time: time, flux_action: action };
    return this.http
      .post("/api/quotes/" + quote_id + "/flux_schedule", params)
      .pipe(tap((_) => console.log("QuoteService.schedule: Ok.")));
  }

  public updateFlux(quote_id: string | number, action: string, options: any) {
    let params = { flux_action: action, options: JSON.stringify(options) };
    return this.http
      .post("/api/quotes/" + quote_id + "/flux_action", params)
      .pipe(tap((_) => console.log("QuoteService.updateFlux: Ok.")));
  }
  public getAvailableTime(activity_id: string | number, quote_id: string) {
    let options = { params: { step: "30", activity_id: activity_id as string, quote_id: quote_id } };
    return this.http
      .get("/api/users/available_flux_time", options)
      .pipe(tap((_) => console.log("QuoteService.getAvailableTime: Ok.")));
  }

  public show(id: string): Observable<any> {
    return this.http.get("/api/quotes/" + id).pipe(tap((_) => console.log("PersonsService.getQuote")));
  }

  public printQuote(titular_id, selected_quotes, quote_details, expiration_date): Observable<any> {
    const options = {
      selected_quotes,
      quote_details,
      expiration_date,
    };
    return this.http
      .post(`/api/persons/${titular_id}/quotes/print_quote`, options, { responseType: "blob" as "json" })
      .pipe(
        tap((_) => {
          console.log("QuoteService.printQuote");
          console.log("quote_details", options);
          this.analyticsService.quoteDownloadEvent(quote_details.id);
        })
      );
  }
}
